import { render, staticRenderFns } from "./A.vue?vue&type=template&id=15209394&scoped=true&"
import script from "./A.vue?vue&type=script&lang=js&"
export * from "./A.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15209394",
  null
  
)

export default component.exports